import { z } from 'zod'

/** The invite route's search: the token from the email's link. Anything else is dropped. */
export const inviteSearchSchema = z.object({
  token: z.string().optional().catch(undefined),
})

export type InviteSearch = z.output<typeof inviteSearchSchema>
